<!--rota da pagina: /contatoDash-->

<template>
  <div class="background">
    <div class="view">
      <b-row>
        <b-col md="6">
          <h1>Contato</h1>
          <p>
            Gerencie as respostas do formulário de contato através da tabela
            abaixo.
          </p>
        </b-col>
        <b-col md="2" class="position">
          <div>
            <botao
              @click="baixar_planilha()"
              Variante="compazulescuro"
              _Tamanho="sm"
              TextoBotao="Exportar planilha"
            />
          </div>
        </b-col>
      </b-row>
      <tabelaContato class="tabela" v-bind:contatos="contatosArray" />
    </div>
  </div>
</template>

<script>
import tabelaContato from "@/components/Dashboard/tabelaContato.vue";
import botao from "@/components/Botao.vue";
import Contato from "@/services/api/Contato";
import { GetCookie } from "@/utils/CookieUtil";
import download from "downloadjs";

export default {
  components: {
    tabelaContato,
    botao
  },
  data() {
    return {
      contatosArray: []
    };
  },
  async beforeCreate() {
    //funcao q preenche o vetor de contatos
    let token = GetCookie("token");

    Contato.GetContato(token).then(response => {
      this.contatosArray = response.data;
      this.contatosArray.sort((a, b) => {
        var dateA = new Date(a.data),
          dateB = new Date(b.data);
        return dateB - dateA;
      });
    });
  },
  methods: {
    async baixar_planilha() {
      let token = GetCookie("token");
      try {
        await Contato.GetSheet(token, "planilha_contato")
          .then(response => {
            let data = new Date(); //timestamp
            const content = response.headers["content-type"];
            download(
              response.data,
              `contatos-${data.toLocaleDateString()}-.xlsx`,
              content
            );
          })
          .catch(e => {
            console.log(e);
          });
      } catch (e) {
        console.log(e.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-family: Montserrat Medium !important;
  margin-top: 27px;
  margin-left: -2vw;
  margin-bottom: 7px;
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  color: #000000;
}
p {
  font-family: Montserrat Regular !important;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.035em;
  color: #4a4a4a;
  margin-left: -2vw;
}
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.background {
  position: absolute;
  height: 100%;
  width: 100%;
  background: #f5f5f5;
}

.view {
  position: absolute;
  left: 9.5vw;
  top: 73px;
  background: #f5f5f5;
}
.tabela {
  width: 90vw;
  margin-top: 18px;
  margin-left: -2vw;
  margin-right: 39px;
}
@media only screen and (orientation: portrait) {
  .tabela {
    width: 1000px;
  }
}

.position {
  margin-top: 12vh;
  margin-left: 29vw;
}

@media (max-width: 480px) {
  .position {
    margin-top: 0;
    margin-left: 9vw;
  }
}

@media only screen and (orientation: portrait) {
  #botao .bt.botao.compazulescuro.sm {
    font-size: 18px;
    min-width: 200px;
    width: 250px;
    min-height: 56px;
    padding: 1.2vw 3.6vw 1.2vw 3.6vw;
  }
}

@media only screen and (orientation: portrait) and (min-width: 769px) and (max-width: 1100px) {
  .view {
    position: absolute;
    max-width: 80%;
    margin-left: -1vw;
  }
  .tabela {
    margin-left: 3vw;
    width: 85vw;
  }
  .position {
    margin-top: -5.5vh;
    margin-left: 77vw;
  }
  h1 {
    margin-left: 3vw;
  }
  p {
    min-width: 50vw;
    margin-left: 3vw;
  }
}

@media only screen and (orientation: portrait) and (max-width: 768px) {
  .view {
    position: absolute;
    max-width: 80%;
    margin-left: 1vw;
  }
  .tabela {
    margin-left: 3vw;
    width: 85vw;
  }
  .position {
    margin-top: -5.5vh;
    margin-left: 77vw;
  }
  h1 {
    margin-left: 3vw;
  }
  p {
    min-width: 50vw;
    margin-left: 3vw;
  }
}

@media only screen and (orientation: landscape) and (min-width: 701px) and (max-width: 1100px) {
  .view {
    position: relative;
    max-width: 95%;
  }
  .tabela {
    margin-top: 0vh;
    width: 78vw;
    margin-left: 2vw;
  }
  .position {
    margin-top: -7vw;
    margin-left: 84vw;
  }
  h1 {
    margin-top: 2vh;
    margin-left: 2vw;
  }
  p {
    margin-left: 2vw;
  }
}

@media only screen and (orientation: landscape) and (max-width: 1201px) {
  .tabela {
    width: 96vw;
  }
}

@media only screen and (orientation: portrait) and (max-width: 480px) and (min-width: 401px) {
  .view {
    position: relative;
    max-width: 70%;
    margin-top: 3vh;
  }
  .tabela {
    width: 92vw;
    margin-left: -7vw;
    margin-right: 4vw;
  }
  .position {
    margin-left: -7vw;
    margin-top: 1vh;
  }
  h1 {
    margin-top: -9vh;
    margin-left: -7vw;
  }
  p {
    margin-left: -7vw;
  }
}

@media only screen and (orientation: landscape) and (max-width: 700px) {
  .view {
    width: 80%;
    position: relative;
  }
  .tabela {
    margin-top: 6vh;
    margin-left: -7vw;
    width: 97vw;
  }
  .position {
    margin-top: 1vh;
    margin-left: -7vw;
  }
  h1 {
    margin-top: -16vh;
    margin-left: -7vw;
  }
  p {
    margin-left: -7vw;
  }
}

@media only screen and (orientation: portrait) and (max-width: 400px) {
  h1 {
    margin-top: -9vh;
    margin-left: -7vw;
  }
  p {
    margin-left: -7vw;
  }
  .tabela {
    margin-left: -7vw;
    width: 90vw;
  }
  .position {
    margin-left: -7vw;
    margin-top: 2vh;
  }
  .view {
    position: relative;
    max-width: 80%;
  }
}
</style>
